import React from 'react';

const WhatWeAre = () => {
          return (
                    <div className='bg-white'>
                              <div class="card   shadow-xl justify-center mx-auto pt-20">
  <div class="card-body">
    {/* <h2 class="card-title text-center text-4xl">We believe in making the best work,and being the best to work with</h2> */}
    
    <p className='text-center text-5xl font-bold text-black'>We believe in making the best work,and</p>
    <p className='text-center text-5xl font-bold text-black'>being the best to work with</p>
    <button className='btn btn-active m-10 rounded-full  bg-black text-white mx-auto text-center justify-items-center justify-center align-middle'>Life at Instrument</button>


    
  </div>
</div>
<div class=" carousel carousel-horizontal rounded-box">
  <div class="carousel-item h-full">
    <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" />
  </div> 
  <div class="carousel-item h-full">
    <img src="https://images.unsplash.com/photo-1538688423619-a81d3f23454b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" />
  </div> 
  <div class="carousel-item h-full">
    <img src="https://images.unsplash.com/photo-1516383740770-fbcc5ccbece0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" />
  </div> 
  <div class="carousel-item h-full">
    <img src="https://images.unsplash.com/photo-1516062423079-7ca13cdc7f5a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=883&q=80" />
  </div> 
  <div class="carousel-item h-full">
    <img src="https://images.unsplash.com/photo-1531539134685-27d854339120?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" />
  </div> 
  <div class="carousel-item h-full">
    <img src="https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" />
  </div> 
  <div class="carousel-item h-full">
    <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" />
  </div>
</div>
<div class="card   shadow-xl justify-center mx-auto mt-12 justify-items-center  align-middle ">
  <div class="card-body">
    {/* <h2 class="card-title text-center text-4xl">We believe in making the best work,and being the best to work with</h2> */}
    
    <p className='text-center text-4xl font-semi-bold justify-center m-12 p-16'>We’re a team of technologists, strategists, and creative problem solvers seeking to make a positive impact on your business and the world around us

</p>
    {/* <p className='text-center text-4xl font-bold'>being the best to work with</p> */}
   


    
  </div>
</div>
<div>

</div>
<div class="card  glass">
  <figure><img src="https://images.prismic.io/instrument-v5/cb15ecd5-f3cf-4e8c-a88c-52b0ef74671e__instrument-2020_j7drfc.jpg?auto=compress,format&w=1920" alt="car!"></img></figure>
  <div class="card-body">

  </div>
</div>
<div>
          <h1 className='text-center text-4xl font-bold m-20'>Leadership</h1>
</div>
<div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-36'>
<div class="card card-compact  bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1541577141970-eebc83ebe30e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body ">
    <h2 class="text-center text-2xl font-bold">James Martin</h2>
  
   
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Michel Phillips</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1581382575275-97901c2635b7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Alex Jhon</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1547992087-e67e3944257e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Shon Mendis</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/flagged/photo-1595514191830-3e96a518989b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Brad Hardin</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1505499663565-1ec2a8397f5b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=408&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Alesa Healy</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1558499932-9609acb6f443?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Sopia Eleceston</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Matt henry</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">James MiLner</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=344&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Brendon Searles</h2>
  
    
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/feead288-01f8-465f-b878-bb3523335c70_balloon-with-hand.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-center text-2xl font-bold">Interested to joining the team?</h2>
    <h2 class="text-center  ">Explore open role</h2>
  
    
  </div>
</div>
</div>
<div class="card-body">
    {/* <h2 class="card-title text-center text-4xl">We believe in making the best work,and being the best to work with</h2> */}
    
    <p className='text-center text-6xl font-semi-bold text-black font-serif'>Let's work together</p>
    {/* <p className='text-center text-4xl font-bold'>being the best to work with</p> */}
    <button className='btn btn-xs sm:btn-sm md:btn-md lg:btn-lg m-12 bg-black text-white rounded-3xl mx-auto text-center justify-items-center justify-center align-middle'>Careers</button>


    
  </div>
                    </div>
          );
};

export default WhatWeAre;